import store from '@/store'

function getProvinceCode(province)
{
    for (let code in store.state.address.areaList.province_list)
    {
        if (store.state.address.areaList.province_list[code] == province)
        {
            return parseInt(code);
        }
    }
}

function getCityCode(city) {
    for (let code in store.state.address.areaList.city_list) {
        if (store.state.address.areaList.city_list[code] == city) {
            return parseInt(code);
        }
    }
}

export {
    getProvinceCode,
    getCityCode,
}